export default {
  container: {
    '&::after': {
      visibility: (props) => (props.required ? 'inherit' : 'hidden'),
      content: '"*"',
      paddingLeft: '0.3rem',
    },
  },
}
